/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import dot from 'dot-object';
import { message } from 'antd';
import React, { useState, useEffect } from "react";
import Loading from "../../../../components/Loading";
import { getToken } from 'datastake-daf/src/helpers/Token';
import DynamicForm from "../../../../components/DynamicFormTif";
import { propHasValue } from "../../../../components/DynamicFormTif/helper";
import { getApiBaseUrl, getAppHeader } from "../../../../services/BaseService";

function AjaxModal({
  formsValue = {},
  name,
  inputName = null,
  call = null,
  value = null,
  onNewSetValue = null,
  repeatValues = {},
  onChange = () => { },
  form = {},
  disabledInputs = [],
  rowToEdit = {},
  isFetching,
  setIsFetching,
}) {
  const [modalVisible, setModalVisible] = useState(false);
  const [config, , v] = call.split('::');
  const [data, setData] = useState(rowToEdit || {});
  const [destroy, setDestory] = useState(false);
  const createEndpoint = `${getApiBaseUrl()}/linking/check`;

  useEffect(() => {
    if (!((modalVisible || value || (data && data.id !== value)) && isFetching)) {
      const extraData = [];
      if (!data || !data.country) {
        extraData.push('country');
      }
      const formData = Object.assign(data || {}, getPredfinedValues(v ? JSON.parse(v) : {}, extraData));
      setData(formData);
    }
  }, [modalVisible, value, isFetching])

  const getPredfinedValues = (predefinedValues, fromForm = []) => {
    Object.keys(predefinedValues).forEach(pv => {
      if (typeof predefinedValues[pv] === 'string' && predefinedValues[pv].split('./').length > 1) {
        let field = predefinedValues[pv].split('./')[1];
        if (field.split('[]').length > 1) {
          field = field.split('[]')[1];
          predefinedValues[pv] = dot.pick(field, repeatValues);
        } else {
          predefinedValues[pv] = dot.pick(field, formsValue);
        }
      }
    })
    if (formsValue && formsValue[name]) {
      let preselectedValues = formsValue[name];
      if (Array.isArray(preselectedValues) && inputName) {
        preselectedValues = preselectedValues.map(pv => pv[inputName]).filter(pv => pv);
      } else if (typeof preselectedValues === 'object' && inputName) {
        preselectedValues = [preselectedValues[inputName]].filter(pv => pv);
      } else if (typeof preselectedValues === 'string') {
        preselectedValues = [preselectedValues].filter(pv => pv);
      } else {
        preselectedValues = [];
      }
      if (Array.isArray(preselectedValues) && preselectedValues.length > 0) {
        predefinedValues.preSelected = preselectedValues;
      }
    }
    fromForm.forEach(n => {
      predefinedValues[n] = formsValue[n];
    })
    return predefinedValues;
  }

  const submit = (payload, setNextForm) => {
    const requestConfig = config ? JSON.parse(config) : {};
    Object.keys(payload).forEach(key => {
      if (typeof payload[key] === 'object' && payload[key] !== null && propHasValue(payload[key])) {
        if (Object.keys(payload[key]).includes('fileList')) {
          const file = (payload[key].fileList || [])
            .map(file => file.response ? file.response : file)
            .filter(file => file && file.status === 'done');
          payload[key] = !Array.isArray(file)
            ? file : file.filter((v, i, a) => a.indexOf(v) === i);
        } else {
          Object.keys(payload[key]).forEach(oKey => {
            if (typeof payload[key][oKey] === 'object' && payload[key][oKey] !== null && propHasValue(payload[key][oKey]) &&
              Object.keys(payload[key][oKey]).includes('fileList')) {
              const file = (payload[key][oKey].fileList || [])
                .map(file => file.response ? file.response : file)
                .filter(file => file && file.status === 'done');
              payload[key][oKey] = !Array.isArray(file)
                ? file : file.filter((v, i, a) => a.indexOf(v) === i);
            }
          })
        }
      }
      if (Array.isArray(payload[key])) {
        // remove empty arrays
        payload[key] = payload[key].filter(f => typeof f !== 'object' || (Object.keys(f).length > 0 && Object.keys(f).filter(fk => propHasValue(f[fk])).length > 0));
      }
    });
    axios.post(createEndpoint, {
      ...requestConfig,
      data: Object.assign(payload, getPredfinedValues(v ? JSON.parse(v) : {})),
    }, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        ...getAppHeader(),
      },
    }).then(({ data }) => {
      setIsFetching(false);
      setNextForm(false);
      setData(data);
      const [, dataId] = onNewSetValue.split('=');
      onChange(dot.pick(dataId, data), data);
      setModalVisible(false);
    }).catch((e) => {
      console.log(e);
      message.error(e.response && e.response.data ? e.response.data.message : e.message);
      setNextForm(false)
      setIsFetching(false);
    })
  }

  useEffect(() => {
    if (destroy) {
      setDestory(false);
    }
  }, [destroy]);

  return (isFetching ? (
    <div className="form-loader"><Loading /></div>
  ) : (
    <DynamicForm
      form={form}
      data={data}
      checkDuplicates={false}
      showSaveAndNext={false}
      disabledInputs={disabledInputs}
      submit={(payload, setNextForm) => {
        submit(payload, setNextForm);
      }}
    />
  ));
}

export default AjaxModal;
